
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { UpdateEntry, UpdateType } from 'ah-api-gateways';
import UpdateEntryCard from './UpdateEntryCard.vue';
import { format, isSameDay, isToday, isYesterday } from 'date-fns';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { useNotificationsStore } from 'ah-notifications/src/store';

@Component({
  components: {
    UpdateEntryCard,
  },
})
export default class UpdatesListing extends Mixins(WithRequestManager) {
  @Prop({ default: null }) updateTypeSelected!: UpdateType | null;

  updates: UpdateEntry[] = [];

  total = -1;

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadUpdates') {
      this.loadMoreItems();
    }
  }

  get notificationsStore() {
    return useNotificationsStore();
  }

  mounted() {
    if (this.notificationsStore.updateUnreadCount > 0) {
      this.notificationsStore.markAllAsRead('updates');
    }
  }

  get hasMoreUpdates() {
    return this.total === -1 || this.updates.length >= this.total;
  }

  onInfiniteLoad(intersection: IntersectionObserverEntry) {
    if (intersection.isIntersecting) {
      this.loadMoreItems();
    }
  }

  isSameDay(a: UpdateEntry, b: UpdateEntry) {
    return isSameDay(new Date(a.date), new Date(b.date));
  }

  loadMoreItems() {
    this.requestManager
      .currentOrNew(
        'loadUpdates',
        this.$services.updates.listUpdateEntries({
          sort: 'date,desc',
          type: this.updateTypeSelected || undefined,
        })
      )
      .subscribe((list) => {
        this.total = list.total;
        this.updates.push(...list.list);
      });
  }

  formatDate(date: string) {
    if (isToday(new Date(date))) {
      return 'TODAY';
    } else if (isYesterday(new Date(date))) {
      return 'YESTERDAY';
    }

    return format(new Date(date), 'EEEE, LLLL d yyyy');
  }

  get noUpdates() {
    return !this.updates || this.updates.length === 0;
  }

  @Watch('updateTypeSelected', { immediate: true })
  onUpdateTypeChanges() {
    this.updates = [];
    this.total = -1;
    this.loadMoreItems();
  }
}
